module.exports = __webpack_public_path__ + "static/img/card_bg.53cc07e.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/movie/card_bg.png
// module id = /18q
// module chunks = 1